import { useCallback } from 'react'

import { type LegalEntitySummaryWithBaseCurrency } from '@webapp/platform/legal-entities/entities/LegalEntitySummaryWithBaseCurrency'
import { useQueryUserLegalEntities } from '@webapp/platform/legal-entities/features/get-user-legal-entities/models/useQueryUserLegalEntities'

/**
 * Resolves a `legal_entity` filter URL param against the user's assigned
 * Legal Entities. An id the user cannot select resolves to `undefined`; pair
 * with `useRemoveUnresolvedLegalEntityFilter` to drop unresolved values.
 */
export const useResolveLegalEntityFilter = () => {
  const { legalEntities } = useQueryUserLegalEntities()

  return useCallback(
    (paramValue: string): LegalEntitySummaryWithBaseCurrency | undefined =>
      legalEntities.find(
        (legalEntity) => String(legalEntity.id) === paramValue
      ),
    [legalEntities]
  )
}
